module.exports = __webpack_public_path__ + "img/creditCardManualRe.fd74dd98.svg";